import React from 'react';
import {
  IonItem,
  IonLabel,
  IonSelect,
  IonSelectOption,
} from '@ionic/react';
import { useTags } from '../../tags/tags-provider';
import { TagType } from '../../tags/tags-schema';

interface ProductSelectorProps {
  selectedProducts: string[];
  onSelectProduct: (productId: string) => void;
  label: string;
  placeholder?: string;
}

const ProductSelector: React.FC<ProductSelectorProps> = ({
  selectedProducts,
  onSelectProduct,
  label,
  placeholder = "Select a product or create new"
}) => {
  const { tags } = useTags();

  const availableProducts = tags?.filter((tag: TagType) => 
    !selectedProducts.includes(tag.id) && tag.isProduct === true
  ) || [];

  return (
    <IonItem>
      <IonLabel position="stacked">{label}</IonLabel>
      <IonSelect
        placeholder={placeholder}
        onIonChange={e => onSelectProduct(e.detail.value)}
        value=""
      >
        {availableProducts.map((product: TagType) => (
          <IonSelectOption key={product.id} value={product.id}>
            {product.displayName}
          </IonSelectOption>
        ))}
        <IonSelectOption value="create-new">Create New Product...</IonSelectOption>
      </IonSelect>
    </IonItem>
  );
};

export default ProductSelector;
